import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import {
  backOfficeRoutes,
  customerRoutes,
  commonRoutes,
  publicRoutes,
  sharedPublicRoutes,
} from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { adminStore } from "stores/admin.store";
import { authStore } from "stores/auth.store";
import Loading from "components/shared-components/Loading";

const Routes = () => {
  const { userProfile, profileLoaded } = adminStore();
  //const token = authStore((state) => state.token);
  const { isAuthenticated } = authStore();

  const userType = userProfile?.userType;
  if (isAuthenticated && !profileLoaded) {
    return <Loading cover="content" />;
  }

  const activeRoutes = [
    ...commonRoutes,
    ...(userType === "backOffice" ? backOfficeRoutes : customerRoutes),
  ];
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
        />
        {activeRoutes.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  permissions={route?.permissions}
                  roles={route?.roles}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>

      {sharedPublicRoutes.map((route, index) => (
        <Route
          key={route.key + index}
          path={route.path}
          element={
            <AppRoute
              routeKey={route.key}
              component={route.component}
              permissions={route?.permissions}
              roles={route?.roles}
              {...route.meta}
            />
          }
        />
      ))}

      <Route path="*" element={<Navigate to="/" replace />} />
    </RouterRoutes>
  );
};

export default Routes;
